module.exports = __webpack_public_path__ + "img/5.e4a344ba.png";